import { Flex, SkeletonText, Table, TableContainer, Tbody, Td, Th, Thead } from '@chakra-ui/react';
import TableRow from 'components/TableRow';
import IconAction from 'containers/IconAction';
import UploadErrorAlert from 'containers/UploadErrorAlert';
import React from 'react';
import { GetDocumentResponse } from 'redux/services/documentRepository/types';

interface AdditionalDataProps {
    isLoading: boolean;
    hasError: boolean;
    errorMessages: string[];
    doc?: GetDocumentResponse
}

const AdditionalData = (
    { isLoading, hasError, errorMessages, doc }: AdditionalDataProps
) => {
    if (hasError) {
        return <UploadErrorAlert errs={errorMessages} />;
    }

    return (
        <Flex my="20px" flexDir={"column"}>
            <TableContainer>
                <Table size="sm">
                    <Thead>
                        <TableRow>
                            <Th>
                                <Flex gap={3} align="center">
                                    File details
                                </Flex>
                            </Th>
                            <Th></Th>
                        </TableRow>
                    </Thead>
                    <Tbody>
                        <TableRow>
                            <Td>
                                <Flex align="center" gap={3}>
                                    Anti Virus Scan
                                    <IconAction
                                        isLoading={isLoading}
                                        antiVirusStatus={doc?.data?.antiVirusStatus}
                                    />
                                </Flex>
                            </Td>
                            {isLoading ? (
                                <Td>
                                    <SkeletonText noOfLines={1} width="70px" />
                                </Td>
                            ) : (
                                <Td>{doc?.data?.antiVirusStatus}</Td>
                            )}
                        </TableRow>
                    </Tbody>
                </Table>
            </TableContainer>
        </Flex>
    );
};

export default AdditionalData;
